/**
 * cancelled-branch — quem está DEPOIS da saída "Cancelado" de um Aguardar
 * (spec 2026-09-20 §7.2, Fase 4b).
 *
 * Serve para a tela oferecer `{{cancelamento.*}}` só onde esse bloco existe de
 * verdade em runtime: o desvio é o que enche `cancelamento`, e ele só acontece
 * pelo lado vermelho. Oferecer a variável num nó do lado verde seria convite a
 * escrever um texto que nunca preenche.
 *
 * Olha só as LIGAÇÕES: o ponto de partida é toda ligação que sai da marca
 * `cancelled` (`WORKFLOW_WAIT_CANCELLED_HANDLE`) e a varredura desce por
 * qualquer ligação a partir dali. Desenho com ciclo não trava — cada nó entra
 * uma vez só.
 */
import { WORKFLOW_WAIT_CANCELLED_HANDLE } from '@troia-v3/types';

/** Forma mínima de ligação que a varredura precisa (serve à do React Flow e à da definição). */
export interface CancelledBranchEdge {
  source: string;
  target: string;
  sourceHandle?: string | null | undefined;
}

/**
 * O nó está abaixo de alguma saída "Cancelado"?
 *
 * O próprio Aguardar NÃO está: ele roda antes do desvio, e o bloco
 * `cancelamento` só existe depois dele.
 */
export function isBelowCancelledOutput(
  edges: ReadonlyArray<CancelledBranchEdge>,
  nodeId: string,
): boolean {
  const reached = new Set<string>();
  const queue: string[] = [];

  for (const edge of edges) {
    if (edge.sourceHandle === WORKFLOW_WAIT_CANCELLED_HANDLE && !reached.has(edge.target)) {
      reached.add(edge.target);
      queue.push(edge.target);
    }
  }

  while (queue.length > 0) {
    const current = queue.shift();
    if (current === undefined) break;
    if (current === nodeId) return true;
    for (const edge of edges) {
      if (edge.source === current && !reached.has(edge.target)) {
        reached.add(edge.target);
        queue.push(edge.target);
      }
    }
  }

  return reached.has(nodeId);
}
